import { httpClient } from '@/services/http/httpClient'
import { Actors } from '@/types/actors'

import type { User } from '../../usersService/types'

export type VerifyAuthCodeParams = {
  email: string
  authenticationCode: string
}

export type VerifyAuthCodeResponse = {
  token: string
  user: User
}

export async function verifyAuthCode({
  email,
  authenticationCode,
}: VerifyAuthCodeParams) {
  const { data } = await httpClient.post('/users/sessions/verify', {
    email,
    authenticationCode,
  })

  return {
    token: data.token,
    user: {
      id: data.user.id,
      registration: data.user.registration,
      name: data.user.name,
      profilePhoto: data.user.image,
      isAdmin: data.user.isAdmin,
      // isManager: data.user.isManager,
      isFirstAccess: data.user.firstAccess === null,
      isAcceptedTerms: !!data.user.acceptedTerms,
      isProjectAdmin: data.user.isProjectAdmin,
      email: data.user.email,
      role:
        data.user.isManager || data.user.isAdmin
          ? Actors.MANAGER
          : Actors.IDEATOR,
      // rank: data.user.rank ?? 0,
      // points: data.user.points ?? 0,
      passwordChangeRequired: data.user.passwordChangeRequired,
    },
  }
}
